<script>
  /* eslint-disable new-cap */

import Layout from '@layouts/primary'
import { driverMethods } from '@state/helpers'
import ListLoading from '../../components/loading'

export default {
  $_veeValidate: {
    validator: 'new',
  },
  page: {
    title: 'DriverCenter',
    meta: [{ name: 'description', content: 'ClientCenter' }],
  },
  components: { Layout, ListLoading },
  data() {
    return {
      search: '',
      loadingData:true,
      selectedFile: null,
      headers: [
        { text: 'Name', value: 'name' },
        { text: 'Mobile', value: 'mobile' },
        { text: 'Email', value: 'email' },
        { text: 'License No.', value: 'driversLicenceNo' },
        { text: 'License Expiry Date', value: 'dateSeconds' },
        { text: 'Emergency Contact', value: 'emergencyContactName'},
        { text: 'Actions', value: 'name', sortable: false },
      ],
      drivers: [],
      newDriver: {
        name: null,
        username: null,
        mobile: null,
        email: null,
        password: null,
        driversLicenceNo: null,
        driversLicenceExpiry: null,
        emergencyContactName: null,
        emergencyContactNumber: null,
        deleted_at: null,
      },
      dictionary: {
        attributes: {
          email: 'E-mail Address',
          // custom attributes
        },
        custom: {
          name: {
            required: () => 'Name can not be empty',
            max: 'The name field may not be greater than 10 characters',
            // custom messages
          },
          select: {
            required: 'Select field is required',
          },
          driversLicenceNo:{
            required: 'Drivers license is required'
          },
          driversLicenceExpiry:{
            required: 'Expiry date is required'
          }
        },
      },
      addDriver: false,
    }
  },
  mounted() {
    this.$validator.localize('en', this.dictionary)
    let moment = require('moment');
    this.getDrivers().then(response => {
      let obj = this.$store.state.drivers.objects
      for (let v in obj) {
        // console.log(obj[v])
        obj[v].drivers_licence_expiry_formatted = moment(obj[v].drivers_licence_expiry).format('DD/MM/YYYY');
        obj[v].dateSeconds = moment(obj[v].drivers_licence_expiry).valueOf()
        if(obj[v].deleted_at === null) {
          this.drivers.push(obj[v])
        }
      }
      this.loadingData=false
    // eslint-disable-next-line handle-callback-err
    }).catch(error => {
      this.loadingData=false
    })
    // console.log(this.drivers)
  },
  methods: {
    ...driverMethods,
    async onFileSelected(event){
      this.selectedFile = event.target.files[0];
    },
    async submit() {
      await this.$validator.validateAll().then((response) => {
        if(response){
          this.createDriver(this.newDriver).then( d => {
            location.reload()
          })
        }
      })
    },
    clear() {
      this.newDriver.name = ''
      this.newDriver.username = ''
      this.newDriver.email = ''
      this.newDriver.mobile = ''
      this.newDriver.password = ''
      this.newDriver.driversLicenceNo = ''
      this.newDriver.driversLicenceExpiry = ''
      this.newDriver.emergencyContactName = ''
      this.newDriver.emergencyContactNumber = ''
      this.$validator.reset()
      this.addDriver = false
    },
    changeRoute(r) {
      this.$router.push(r)
    },
  },
}
</script>

<template>
  <Layout>
    <VContainer>
      <div class="">
        <h2 :class="$style.routeHeader">
          Driver Center
        </h2>
        <VBtn
          v-if="!loadingData"
          slot="activator"
          :class="$style.addButton"
          color="blue"
          @click="addDriver = !addDriver"
        >
          + ADD DRIVER
        </VBtn>
      </div>
      <ListLoading :display="loadingData" />
      <VLayout style="width: 100%">

        <VFlex
          xs0
          sm12
        />
        <VFlex
          xs12
          md5
        >
          <VTextField
            v-if="!loadingData"
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          />
        </VFlex>
      </VLayout>

      <VDataTable
        v-if="!loadingData"
        :headers="headers"
        :items="drivers"
        :search="search"
        rows-per-page-text=""
        :rows-per-page-items="[10]"
      >
        <!-- IF THERE IS A MECHANIC ACCOUNT TO USE ON THE APP WHICH IS HIDDEN ON THE WEB APP, IN ORDER TO AVOID DELETE IT -->
        <template
          v-if="props.item.name !== 'mechanic'"
          slot="items"
          slot-scope="props"
        >
          <td class="text-xs-left">
            {{ props.item.name }}
          </td>
          <td class="text-xs-left">
            <i
              class="fas fa-phone"
              :class="$style.iconSpace"
            /> {{ props.item.mobile }}
          </td>
          <td class="text-xs-left">
            <i
              class="fas fa-envelope"
              :class="$style.iconSpace"
            /> {{ props.item.email }}
          </td>
          <td class="text-xs-left">
            {{ props.item.drivers_licence_no }}
          </td>
          <td class="text-xs-left">
            {{ props.item.drivers_licence_expiry_formatted }}
          </td>
          <td class="text-xs-left">
            <i
              class="fas fa-phone"
              :class="$style.iconSpace"
            />
            {{ props.item.emergency_contact_no }} - {{ props.item.emergency_contact_name }}
          </td>

          <td class="justify-center px-0">
            <VBtn
              slot="activator"
              style="display: block; position:relative; margin: 0 auto"
              color="blue"
              @click.native="changeRoute({name: 'view-driver', params: {id: props.item.id}})"
            >
              View
            </VBtn>
          </td>
        </template>
        <VAlert
          slot="no-results"
          :value="true"
          color="error"
          icon="warning"
        >
          Your search for "{{ search }}" found no results.
        </VAlert>
      </VDataTable>
    </VContainer>

    <!-- ADD DRIVER MODAL -->
    <VLayout
      row
      justify-center
    >
      <VDialog
        v-model="addDriver"
        persistent
        max-width="500px"
        scrollable
      >
        <VCard>
          <VCardText>
            <VContainer grid-list-md>
              <h2>Add Driver</h2>
              <VLayout wrap>
                <VFlex
                  xs12
                  sm6
                >
                  <VTextField
                    v-model="newDriver.name"
                    v-validate="'required'"
                    label="Name"
                    required
                    :error-messages="errors.collect('name')"
                    data-vv-name="name"
                  />
                </VFlex>

                <VFlex
                  xs12
                  sm6
                >
                  <VTextField
                    v-model="newDriver.mobile"
                    v-validate="'required'"
                    label="Mobile"
                    required
                    :error-messages="errors.collect('mobile')"
                    data-vv-name="mobile"
                    type="number"
                  />
                </VFlex>

                <VFlex xs12>
                  <VTextField
                    v-model="newDriver.email"
                    v-validate="'required|email'"
                    label="Email"
                    required
                    :error-messages="errors.collect('email')"
                    data-vv-name="email"
                  />
                </VFlex>

                <VFlex
                  xs12
                  sm6
                >
                  <VTextField
                    v-model="newDriver.username"
                    v-validate="'required'"
                    label="Username"
                    required
                    :error-messages="errors.collect('username')"
                    data-vv-name="username"
                  />
                </VFlex>

                <VFlex
                  xs12
                  sm6
                >
                  <VTextField
                    v-model="newDriver.password"
                    v-validate="'required'"
                    label="Password"
                    required
                    :error-messages="errors.collect('password')"
                    data-vv-name="password"
                  />
                </VFlex>
                <VFlex
                  xs12
                  sm6
                >
                  <VTextField
                    v-model="newDriver.driversLicenceNo"
                    v-validate="'required'"
                    label="Drivers License No."
                    required
                    :error-messages="errors.collect('driversLicenceNo')"
                    data-vv-name="driversLicenceNo"
                  />
                </VFlex>

                <VFlex
                  xs12
                  sm6
                >
                  <VTextField
                    v-model="newDriver.driversLicenceExpiry"
                    v-validate="'required'"
                    label="Expiry Date"
                    required
                    :error-messages="errors.collect('driversLicenceExpiry')"
                    data-vv-name="driversLicenceExpiry"
                    type="date"
                  />
                </VFlex>

                <VFlex
                  xs12
                  sm6
                >
                  <VTextField
                    v-model="newDriver.emergencyContactName"
                    v-validate="'required'"
                    label="Emergency Contact"
                    required
                    :error-messages="errors.collect('emergencyContactName')"
                    data-vv-name="emergencyContactName"
                  />
                </VFlex>

                <VFlex
                  xs12
                  sm6
                >
                  <VTextField
                    v-model="newDriver.emergencyContactNumber"
                    v-validate="'required'"
                    label="Emergency Phone"
                    required
                    :error-messages="errors.collect('emergencyContactNumber')"
                    data-vv-name="emergencyContactNumber"
                  />
                </VFlex>

                <!--<VSpacer />-->

                <VFlex
                  xs12
                  sm6
                  md6
                >
                  <VBtn
                    color="blue"
                    block
                    outline
                    @click.native="clear()"
                  >
                    Close
                  </VBtn>
                </VFlex>
                <VFlex
                  xs12
                  sm6
                  md6
                >
                  <VBtn
                    color="blue"
                    block
                    @click.native="submit()"
                  >
                    Save
                  </VBtn>
                </VFlex>
              </VLayout>
            </VContainer>
          </VCardText>
        </VCard>
      </VDialog>
    </VLayout>

  </Layout>
</template>

<style lang="scss" module>
@import '@design';

.routeHeader {
  display: inline-block;
}

.iconSpace{
margin-right:4px;
}

.addButton {
  display: inline-block;
  float: right;
}
</style>
